// actions.js
export const FETCH_TICKETS_REQUEST = 'FETCH_TICKETS_REQUEST';
export const FETCH_FILTER_TICKETS_REQUEST = 'FETCH_FILTER_TICKETS_REQUEST';
export const FETCH_TICKET_REQUEST = 'FETCH_TICKET_REQUEST';
export const UPDATE_TICKET_TECHNICIAN_REQUEST = 'UPDATE_TICKET_TECHNICIAN_REQUEST';
export const UPDATE_TICKET_STATUS_REQUEST = 'UPDATE_TICKET_STATUS_REQUEST';
export const CREATE_TICKET_REQUEST = 'CREATE_TICKET_REQUEST';
export const UPDATE_TICKET_REQUEST = 'UPDATE_TICKET_REQUEST';
export const CLOSE_TICKET_REQUEST = 'CLOSE_TICKET_REQUEST';
export const CREATE_TICKET_COMMENT_REQUEST = 'CREATE_TICKET_COMMENT_REQUEST';
export const DELETE_TICKET_COMMENT_REQUEST = 'DELETE_TICKET_COMMENT_REQUEST';
export const UPDATE_TICKET_MATERIAL_REQUEST = 'UPDATE_TICKET_MATERIAL_REQUEST';

export const FETCH_TICKETS_SUCCESS = 'FETCH_TICKETS_SUCCESS';
export const FETCH_FILTER_TICKETS_SUCCESS = 'FETCH_FILTER_TICKETS_SUCCESS';
export const FETCH_TICKET_SUCCESS = 'FETCH_TICKET_SUCCESS';
export const UPDATE_TICKET_TECHNICIAN_SUCCESS = 'UPDATE_TICKET_TECHNICIAN_SUCCESS';
export const UPDATE_TICKET_STATUS_SUCCESS = 'UPDATE_TICKET_STATUS_SUCCESS';
export const CREATE_TICKET_SUCCESS = 'CREATE_TICKET_SUCCESS';
export const UPDATE_TICKET_SUCCESS = 'UPDATE_TICKET_SUCCESS';
export const CLOSE_TICKET_SUCCESS = 'CLOSE_TICKET_SUCCESS';
export const CREATE_TICKET_COMMENT_SUCCESS = 'CREATE_TICKET_COMMENT_SUCCESS';
export const DELETE_TICKET_COMMENT_SUCCESS = 'DELETE_TICKET_COMMENT_SUCCESS';
export const UPDATE_TICKET_MATERIAL_SUCCESS = 'UPDATE_TICKET_MATERIAL_SUCCESS';

export const FETCH_TICKETS_FAILURE = 'FETCH_TICKETS_FAILURE';
export const FETCH_FILTER_TICKETS_FAILURE = 'FETCH_FILTER_TICKETS_FAILURE';
export const FETCH_TICKET_FAILURE = 'FETCH_TICKET_FAILURE';
export const UPDATE_TICKET_TECHNICIAN_FAILURE = 'UPDATE_TICKET_TECHNICIAN_FAILURE';
export const UPDATE_TICKET_STATUS_FAILURE = 'UPDATE_TICKET_STATUS_FAILURE';
export const CREATE_TICKET_FAILURE = 'CREATE_TICKET_FAILURE';
export const UPDATE_TICKET_FAILURE = 'UPDATE_TICKET_FAILURE';
export const CLOSE_TICKET_FAILURE = 'CLOSE_TICKET_FAILURE';
export const CREATE_TICKET_COMMENT_FAILURE = 'CREATE_TICKET_COMMENT_FAILURE';
export const DELETE_TICKET_COMMENT_FAILURE = 'DELETE_TICKET_COMMENT_FAILURE';
export const UPDATE_TICKET_MATERIAL_FAILURE = 'UPDATE_TICKET_MATERIAL_FAILURE';

export const fetchTicketsRequest = (data) => ({ type: FETCH_TICKETS_REQUEST, payload: data });
export const fetchFilterTicketsRequest = (data) => ({ type: FETCH_FILTER_TICKETS_REQUEST, payload: data });
export const fetchTicketRequest = (data) => ({ type: FETCH_TICKET_REQUEST, payload: data });
export const updateTicketTechnicianRequest = (data) => ({ type: UPDATE_TICKET_TECHNICIAN_REQUEST, payload: data });
export const updateTicketStatusRequest = (data) => ({ type: UPDATE_TICKET_STATUS_REQUEST, payload: data });
export const createTicketRequest = (data) => ({ type: CREATE_TICKET_REQUEST, payload: data });
export const updateTicketRequest = (data) => ({ type: UPDATE_TICKET_REQUEST, payload: data });
export const closeTicketRequest = (data) => ({ type: CLOSE_TICKET_REQUEST, payload: data });
export const createTicketCommentRequest = (data) => ({ type: CREATE_TICKET_COMMENT_REQUEST, payload: data });
export const deleteTicketCommentRequest = (data) => ({ type: DELETE_TICKET_COMMENT_REQUEST, payload: data });
export const updateTicketMaterialRequest = (data) => ({ type: UPDATE_TICKET_MATERIAL_REQUEST, payload: data });

export const fetchTicketsSuccess = (data) => ({ type: FETCH_TICKETS_SUCCESS, payload: data });
export const fetchFilterTicketsSuccess = (data) => ({ type: FETCH_FILTER_TICKETS_SUCCESS, payload: data });
export const fetchTicketSuccess = (data) => ({ type: FETCH_TICKET_SUCCESS, payload: data });
export const updateTicketTechnicianSuccess = (data) => ({ type: UPDATE_TICKET_TECHNICIAN_SUCCESS, payload: data });
export const updateTicketStatusSuccess = (data) => ({ type: UPDATE_TICKET_STATUS_SUCCESS, payload: data });
export const createTicketSuccess = (data) => ({ type: CREATE_TICKET_SUCCESS, payload: data });
export const updateTicketSuccess = (data) => ({ type: UPDATE_TICKET_SUCCESS, payload: data });
export const closeTicketSuccess = (data) => ({ type: CLOSE_TICKET_SUCCESS, payload: data });
export const createTicketCommentSuccess = (data) => ({ type: CREATE_TICKET_COMMENT_SUCCESS, payload: data });
export const deleteTicketCommentSuccess = (data) => ({ type: DELETE_TICKET_COMMENT_SUCCESS, payload: data });
export const updateTicketMaterialSuccess = (data) => ({ type: UPDATE_TICKET_MATERIAL_SUCCESS, payload: data });

export const fetchTicketsFailure = (error) => ({ type: FETCH_TICKETS_FAILURE, payload: error });
export const fetchFilterTicketsFailure = (error) => ({ type: FETCH_FILTER_TICKETS_FAILURE, payload: error });
export const fetchTicketFailure = (error) => ({ type: FETCH_TICKET_FAILURE, payload: error });
export const updateTicketTechnicianFailure = (error) => ({ type: UPDATE_TICKET_TECHNICIAN_FAILURE, payload: error });
export const updateTicketStatusFailure = (error) => ({ type: UPDATE_TICKET_STATUS_FAILURE, payload: error });
export const createTicketFailure = (error) => ({ type: CREATE_TICKET_FAILURE, payload: error });
export const updateTicketFailure = (error) => ({ type: UPDATE_TICKET_FAILURE, payload: error });
export const closeTicketFailure = (error) => ({ type: CLOSE_TICKET_FAILURE, payload: error });
export const createTicketCommentFailure = (error) => ({ type: CREATE_TICKET_COMMENT_FAILURE, payload: error });
export const deleteTicketCommentFailure = (error) => ({ type: DELETE_TICKET_COMMENT_FAILURE, payload: error });
export const updateTicketMaterialFailure = (error) => ({ type: UPDATE_TICKET_MATERIAL_FAILURE, payload: error });